import { Add } from '@mui/icons-material';
import { Box, Fab, useScrollTrigger } from '@mui/material';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import {
  OPEN_ADD_TRANSACTION_STATE_KEY,
  TRANSACTION_FAB_LABEL,
  TRANSACTION_FAB_TARGET_PATH,
  isTransactionFabVisible,
} from '../../constants/navigation';

/**
 * 전역 "거래 기록" 확장 FAB (모바일 전용 — Layout 이 isMobile 일 때만 렌더).
 *
 * - 노출 경로는 constants/navigation 의 TRANSACTION_FAB_PATHS.
 * - 클릭: /transactions 로 이동 + state { openAddTransaction: true }.
 *   이미 거래내역 화면이면 같은 경로에 state 만 갱신(replace)해서 다이얼로그를 바로 연다.
 * - 스크롤을 내리면 라벨을 접어 아이콘만, 올리면 다시 펼친다.
 * - 동작 버튼이므로 거래 방향 색(gain/loss)이 아니라 중립 primary.
 */
const AddTransactionFab = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // 아래로 스크롤 중이면 true, 위로 올리면 false (맨 위 근처에서는 항상 false)
  const collapsed = useScrollTrigger({ threshold: 48 });

  if (!isTransactionFabVisible(location.pathname)) {
    return null;
  }

  const handleClick = () => {
    navigate(TRANSACTION_FAB_TARGET_PATH, {
      state: { [OPEN_ADD_TRANSACTION_STATE_KEY]: true },
      replace: location.pathname === TRANSACTION_FAB_TARGET_PATH,
    });
  };

  return (
    <Fab
      variant="extended"
      color="primary"
      aria-label={TRANSACTION_FAB_LABEL}
      onClick={handleClick}
      sx={{
        position: 'fixed',
        right: { xs: 16, sm: 20 },
        // 하단 탭(xs 56px / sm 60px) 위로 띄운다
        bottom: {
          xs: 'calc(72px + env(safe-area-inset-bottom, 0px))',
          sm: 'calc(76px + env(safe-area-inset-bottom, 0px))',
        },
        zIndex: (theme) => theme.zIndex.speedDial,
        minWidth: 48,
        height: 48,
        px: 2,
        boxShadow: (theme) => theme.shadows[6],
      }}
    >
      <Add aria-hidden="true" />
      <Box
        component="span"
        aria-hidden="true"
        sx={{
          display: 'inline-block',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          maxWidth: collapsed ? 0 : 80,
          ml: collapsed ? 0 : 1,
          opacity: collapsed ? 0 : 1,
          transition: 'max-width 0.2s ease, margin 0.2s ease, opacity 0.2s ease',
          '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
        }}
      >
        {TRANSACTION_FAB_LABEL}
      </Box>
    </Fab>
  );
};

export default AddTransactionFab;
